// extracted by mini-css-extract-plugin
export default {"tube":"CRT_tube__HfqGf","glass":"CRT_glass__NUw+r","staticNoise":"CRT_staticNoise__O21fd","refreshBand":"CRT_refreshBand__hfgJf"};